import { Box, Button, Stack, TextField } from "@mui/material";
import { useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useImmer } from "use-immer";
import { postComponents, updateComponents } from "../../../../../api/services";
import Quill from "../../../../../components/Quill";

export const ExperimentForm = ({ data, close }: any) => {
  const queryClient = useQueryClient();
  const { id: subjectId } = useParams();
  const [search] = useSearchParams();
  const topicId = search.get("topicId");
  const chapterId = search.get("chapterId");
  const sectionId = search.get("sectionId");

  const [state, setState] = useImmer<{
    title: string;
    description: string;
  }>({
    description: "",
    title: "",
  });

  useEffect(() => {
    setState({
      title: data?.title || "",
      description: data?.description || "",
    });
  }, [data]);

  const { mutate } = useMutation(postComponents, {
    onSuccess: (res: any) => {
      toast.success(res?.data?.message);
      queryClient.invalidateQueries("topic-id");
      close();
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message);
    },
  });

  const { mutate: updateMutate } = useMutation(updateComponents, {
    onSuccess: (res: any) => {
      toast.success("Test Updated Successfully");
      queryClient.invalidateQueries("topic-id");
      close();
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message);
    },
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const res = {
      subjectId,
      chapterId,
      topicId,
      sectionId,
      type: "EXPERIMENT",
      ...state,
    };
    if (data?._id) {
      updateMutate({ id: data?._id, body: res });
    } else {
      mutate(res);
    }
  };

  const handleChange = (value: any) => {
    setState((s: any) => {
      s.description = value;
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack gap={2}>
        <TextField
          fullWidth
          required
          label="Title"
          value={state.title}
          onChange={(e) =>
            setState((s) => {
              s.title = e.target.value;
            })
          }
        />
        <Quill
          data={state?.description}
          handleChange={(value) => handleChange(value)}
        />
        <Box>
          <Button variant="contained" type="submit">
            Submit
          </Button>
        </Box>
      </Stack>
    </form>
  );
};
